
    import { Component, Prop, Vue } from "vue-property-decorator";
    import ServiceLink from "./ServiceLink.vue";
    import servicesLinks from "./services-links";
    @Component({
  components: {
    ServiceLink
  },
})
export default class ServicesNav extends Vue {
  @Prop({default: false}) public isMain!: boolean;
  servicesLinks = servicesLinks;

}
